import { Touchable, Video } from '@kalyzee/kast-web-sdk/web-components';
import React from 'react';

export interface SelfPreviewProps {
  color: string;
  stream?: MediaStream;
  icon: React.ReactNode;
  onClick?: () => void;
}

const SelfPreview: React.FC<SelfPreviewProps> = ({ color, stream, icon, onClick }) => {
  return (
    <Touchable
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: 70,
        border: `2px solid ${color}`,
        borderRadius: 4,
        backgroundColor: color,
      }}
      onPress={onClick}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 4,
          overflow: "hidden", // crop video
          height: "100%",
          width: 90,
        }}
      >
        {stream ? (
          <Video
            style={{ flex: 1, height: "100%", minWidth: 0, objectFit: "cover", background: 'black' }}
            src={stream}
            autoPlay
            muted
          />
        ) : (
          <div
            style={{
              fontSize: "0.6em",
              flex: 1,
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Pas de Media
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px 3px",
          height: "100%",
        }}
      >
        {icon}
      </div>
    </Touchable>
  );
};

export default SelfPreview;